export const CardsData = [
  {
    title: 'Besondere Bewerbung',
    slug: 'bewerbung/besondere-bewerbung',
    articles: [
      {
        pageTitle: 'Lars Hahn',
        title:
          'Jobsuche 2023: Warum eine Bewerbung per ChatGPT noch keine gute Idee ist',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZjc3NGIwMjctYWI0Yi00NjAwLTljZTUtYTkxOTA4MjEwZmQ2IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=59b478f00d1ca446ce26a564f9a8a803f9b7f53387f85aa14e0a09c11ebbc95a',
        description:
          'Künstliche Intelligenz ist gerade dabei, unsere Arbeitswelt zu erobern. Mit Chat GPT kann man bereits Texte automatisiert erstellen lassen, also auch Bewerbungsanschreiben und Co. Eine gute Idee, oder eher nicht?',
        url: 'https://www.xing.com/news/article/jobsuche-2023-warum-eine-bewerbung',
        profileImage:
          'https://profile-images.xing.com/images/b62adc10428ce9e8db9a0a96aa332617-42/lars-hahn.256x256.jpg',
      },
      {
        pageTitle: 'Jochen Mai',
        title: 'Mit Wutbewerbungen gegen zu wenig Wertschätzung',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/343/141/web_high/481f87f154da7e89044a23afa2f4a4b2f56594f8image.jpg?1673982130',
        description:
          'Jeder dritte Arbeitnehmer würde am liebsten noch in den kommenden sechs Monaten seinen Job wechseln. ',
        url: 'https://www.xing.com/news/insiders/articles/mit-wutbewerbungen-gegen-zu-wenig-wertschatzung-5434697',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/822/523/square_48/ece1be35ac76c183e662e40eff97fdc1c49b8255image.jpg?1653460545',
      },
      {
        pageTitle: 'Frank Rechsteiner',
        title:
          'So bewirbst du dich als Führungskraft – diese vier Tipps sind Pflicht',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/127/367/web_high/0579b0ff873407985ca001ce68c9b57545436686image.jpg?1665488975',
        description:
          'Richtig digital vernetzt und mit einer guten Portion Selbstbewusstsein, erhöht jeder Manager seine Bewerbungschancen – vor allem wenn er folgende vier Grundregeln beherzigt.',
        url: 'https://www.xing.com/news/insiders/articles/so-bewirbst-du-dich-als-fuhrungskraft-diese-vier-tipps-sind-pflicht-5209052',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/329/685/square_48/b8952f0b96f0b2d1ce1c7c83f870a4125f11671eimage.jpg?1673458667',
      },
      {
        pageTitle: 'NWX – New Work News',
        title: 'Richtig frech: Über diese Bewerber lachen Personaler',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/347/518/web_high/5d2b4d015feec67123f4f1e4683ad8a6f151c32bimage.jpg?1601895259',
        description:
          'Wer denkt, jeden Tag zahlreiche Bewerbungen zu lesen, sei langweilig, der hat sich mächtig getäuscht. Denn die Personaler haben dabei oft eine Menge zum Lachen.',
        url: 'https://www.xing.com/news/articles/richtig-frech-uber-diese-bewerber-lachen-personaler-3530943',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/002/498/801/square_48/fbbd8bd5998209b82b8efffcda32c77e791c3231image.jpg?1569938668',
      },
      {
        pageTitle: 'Job & Karriere',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/537/312/web_high/8bc449e79d6b13635da78ace644a6d8c940d5b29image.jpg?1534760902',
        title: 'Vorsicht: Das hat sich bei modernen Bewerbungen geändert',
        description:
          'Was bewegt die Arbeitswelt heute? In unserer Artikelsammlung erklären wir aktuelle Aspekte, beleuchten unterschiedliche Perspektiven und empfehlen Hintergrundbeiträge – direkt aus der XING-Redaktion.',
        url: 'https://www.xing.com/news/articles/vorsicht-das-hat-sich-bei-modernen-bewerbungen-geandert-1628897',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title:
          'Was tun, wenn Sie auf dem gewöhnlichen Bewerbungsweg nicht erfolgreich sind?',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/001/864/968/web_high/036129cdfe029942dbd0e8509ac24916e1ee7506image.jpg?1547563595',
        description:
          'Wir – das News & Content Team XING Schweiz – empfehlen Ihnen regelmässig lesenswerte Beiträge aus dem Bereich "Job & Karriere“. ',
        url: 'https://www.xing.com/news/articles/was-tun-wenn-sie-auf-dem-gewohnlichen-bewerbungsweg-nicht-erfolgreich-sind-1984095',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
    ],
  },
  {
    title: 'Bewerbungsarten & Formate',
    slug: 'bewerbung/bewerbungsarten-formate',
    articles: [
      {
        pageTitle: 'Job & Karriere Schweiz',
        title: 'Bewerbung als Berufseinsteiger: Tipps zum Durchstarten',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/409/602/web_high/b56ce80e6158e65767420cce857157d3023afcabimage.jpg?1567065012',
        description:
          'Endlich fertig mit der Ausbildung oder dem Studium und bereit, um Karriere zu machen? Viele Berufseinsteiger starten hoch motiviert in den Bewerbungsprozess – und schnell folgt die Ernüchterung. Wie also können Sie wirklich durchstarten?',
        url: 'https://www.xing.com/news/articles/bewerbung-als-berufseinsteiger-tipps-zum-durchstarten-2565890',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'NWX – New Work News',
        title:
          'Bewerben über TikTok? So verändert die Digitalisierung den Bewerbungsprozess',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/003/351/291/web_high/4a4824ff032f6ad264026ba4899cd6a2bae09080image.jpg?1601997938',
        description:
          'Über TikTok, Turbokapitalismus und die neue Attraktivität von Personalmanagement',
        url: 'https://www.xing.com/news/articles/bewerben-uber-tiktok-so-verandert-die-digitalisierung-den-bewerbungsprozess-3534832',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/002/498/801/square_48/fbbd8bd5998209b82b8efffcda32c77e791c3231image.jpg?1569938668',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title: 'Boomerang-Bewerbung: Hallo, da bin ich wieder!',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/748/085/web_high/cf93b89b3049faa1c54a5853e9d9636f26a3bbb1image.jpg?1579513327',
        description:
          'Du hast deinen alten Arbeitgeber für einen neuen Job verlassen und möchtest jetzt wieder zurück? Damit eine Boomerang-Bewerbung gelingt, brauchst du vor allem eines: gute Argumente. Wir haben bei Personalern nachgefragt, wie du überzeugen kannst und die Rückkehr gelingt.',
        url: 'https://www.xing.com/news/articles/boomerang-bewerbung-hallo-da-bin-ich-wieder-2924298',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'Job & Karriere Schweiz',
        title:
          'Hallo, hier bin ich: So wird eine gute Initiativbewerbung aufgebaut',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/441/689/web_high/35e4de8171742fd0551f2a3f35828b004c66016cimage.jpg?1568117416',
        description:
          'Stell dir vor, du hast gerade gelesen, in welchen Unternehmen die Mitarbeiter mit ihren Löhnen am glücklichsten sind. Jetzt siehst du vor deinem inneren Auge natürlich nur noch dicke Scheine und hättest dich am liebsten schon gestern bei diesen Arbeitgebern beworben. ',
        url: 'https://www.xing.com/news/articles/hallo-hier-bin-ich-so-wird-eine-gute-initiativbewerbung-aufgebaut-2600415',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/095/079/square_48/2997b31d8fb51f5b1de30310812a928c3d6b6838image.jpg?1592558965',
      },
      {
        pageTitle: 'XING Talk',
        title:
          'Online statt analog: Wie sich mit digitalen Bewerbungen punkten lässt',
        description:
          'Schnelligkeit und Flexibilität – das sind Eigenschaften, die viele Bewerber heutzutage mitbringen sollten. Und diese sind bereits im Bewerbungsprozess gefragt. ',
        url: 'https://www.xing.com/news/articles/online-statt-analog-wie-sich-mit-digitalen-bewerbungen-punkten-lasst-2224307',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/933/255/square_48/fc59eef108434f54b9e78aa98765278644372177image.jpg?1508401741',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'Tipps für die Initiativbewerbung',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/755/747/web_high/4619eb967531d5656fd665dc3ead012d00fc9d91image.jpg?1499246421',
        description:
          'Sie möchten gern für ein bestimmtes Unternehmen tätig werden, aber es sind aktuell keine Stellen ausgeschrieben? Wir zeigen Ihnen, wann sich eine Initiativbewerbung lohnt und wie Sie damit punkten.',
        url: 'https://www.xing.com/news/articles/tipps-fur-die-initiativbewerbung-810347',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
    ],
  },
  {
    title: 'Tipps zum Anschreiben',
    slug: 'bewerbung/anschreiben',
    articles: [
      {
        pageTitle: 'Campus & Karriere',
        title: "Authentizität im Anschreiben: Wie ehrlich darf's denn sein?",
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/068/438/web_high/6ea6eedcbcce018c6d95c2ad6b1babfdb5aeb7a5image.jpg?1554474326',
        description:
          'Klar, in Ihrer Bewerbung sollten Sie sich ehrlich präsentieren und langweilige Standard-Anschreiben vermeiden. Doch wie viel Authentizität ist taktisch klug?',
        url: 'https://www.xing.com/news/articles/authentizitat-im-anschreiben-wie-ehrlich-darf-s-denn-sein-2201225',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/270/889/square_48/image.jpg?1464946715',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        title: 'So sollte der erste Satz im Anschreiben aussehen',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/002/233/497/web_high/705bd21c7117b16788f1337f56b3987ee43553b8image.jpg?1560503549',
        description:
          'Wenn es Ihnen gelingt, mit Ihrem Anschreibens Interesse zu wecken und den Leser neugierig zu machen, steigen die Chancen für ein Vorstellungsgespräch deutlich. Denn auch wenn Personaler verschieden sind: nichtssagendes Gerede mag keiner.',
        url: 'https://www.xing.com/news/articles/so-sollte-der-erste-satz-im-anschreiben-aussehen-2378708',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
      {
        pageTitle: 'Job & Karriere',
        title: 'So überzeugen Sie im Bewerbungsschreiben',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/000/746/919/web_high/daf4f2d4cbbfac397a575ed0bcc468778d86dfe3image.jpg?1498746831',
        description:
          'Oft ist das Formulieren eines aussagekräftigen Bewerbungsschreibens eine Herausforderung für Bewerber. Wer diese Tipps beherzigt, der hat die Arbeit schon halb erledigt.',
        url: 'https://www.xing.com/news/articles/so-uberzeugen-sie-im-bewerbungsschreiben-801323',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/162/810/square_48/760282e3ecca792fdbd6fbdb605ceabdd0e411b6image.jpg?1666783805',
      },
      {
        pageTitle: 'Nane Nebel',
        title:
          'Bewerbungsanschreiben – Machen sie überhaupt noch Sinn? Ja! Wenn das Richtige drin steht.',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/001/510/329/web_high/cb5e0d068c5e21b37b1cbc4da8943ec46d633bbcimage.jpg?1533644994',
        description:
          'Immer mehr Unternehmen verzichten bei den elektronisch erbetenen Bewerbungsunterlagen auf das Mitschicken eines klassischen Bewerbungsanschreibens. Die dafür genannten Gründe sind vielfältig. ',
        url: 'https://www.xing.com/news/insiders/articles/bewerbungsanschreiben-machen-sie-uberhaupt-noch-sinn-ja-wenn-das-richtige-drin-steht-1599238',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/329/622/square_48/d654cd0fac7b046bc01a013d2c43eb6fc37d84f6image.jpg?1673457989',
      },
      {
        pageTitle: 'Joachim Diercks',
        title:
          'Ist das ein Anschreiben oder kann das weg? Machen Cover Letter Sinn oder sollte man sie abschaffen?',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/003/019/651/web_high/e86813d3de3ffa0e9667ce6c6c30664d47ee533bimage.jpg?1589552537',
        description:
          'Das Thema ist ja fast schon ein Klassiker: Brauchen wir das Anschreiben noch?',
        url: 'https://www.xing.com/news/insiders/articles/ist-das-ein-anschreiben-oder-kann-das-weg-machen-cover-letter-sinn-oder-sollte-man-sie-abschaffen-3203261',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/003/121/043/square_48/95b3fb654f0c8fbc3c85d1dc5154a4d157590cddimage.jpg?1593584891',
      },
      {
        pageTitle: 'Bewerbung & Gehaltsverhandlung',
        title: 'Bewerbungen sind wie Dating: Do’s und Don’ts beim Anschreiben',
        imageSrc:
          'https://static.xingcdn.com/content/fulltext_header_images/images/004/036/296/web_high/d39fad417056ddd39cf66b65b9625197bedcf03cimage.jpg?1630582363',
        description:
          'Bei der Bewerbung auf eine Stellenanzeige gibt es so einiges zu beachten. Im Grunde ist eine Bewerbung wie Dating: Der erste Eindruck zählt, Dein Gegenüber will umgarnt werden und wer langweilig ist, hat schlechte Karten.',
        url: 'https://www.xing.com/news/articles/bewerbungen-sind-wie-dating-do-s-und-don-ts-beim-anschreiben-4241669',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/000/939/708/square_48/0237a55a3e4987ea2a9afdbfed060a544c5a5ba9image.jpg?1508772598',
      },
    ],
  },
  {
    title: 'Tipps zum Lebenslauf',
    slug: 'bewerbung/lebenslauf',
    articles: [
      {
        pageTitle: '',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDNhYzNmZjYtOTJjMC00MDA0LWE5MDQtMjI5Y2Q0NzkwZmJkIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=762d369dee18907f4c98cb8b201231465429fdd665e73df1a0287ef40d8e61ca',
        title:
          'Golfen, Segeln, Reiten – mit diesen Hobbys bekommst Du das Vorstellungsgespräch',
        description:
          'Die „richtigen“ Hobbys in der Bewerbung anzugeben kann große Vorteile haben. Denn sie beeinflussen nicht selten HR-Verantwortliche und Manager bei der Bewerberauswahl. ',
        url: 'https://www.xing.com/news/article/golfen-segeln-reiten-mit-diesen-hob',
        profileImage: '',
      },
      {
        pageTitle: 'Silke Koppitz',
        title:
          '5 „Beige Flags“ in deinem Lebenslauf, die du sofort loswerden solltest',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/703/564/web_high/9ff8602922464fa92364f1d51e61cecd14ea9058image.jpg?1687440267',
        description:
          '„Zu Vino sag ich nie no!“, „Tschö mit ö!“, „Mal verliert man, und mal gewinnen die anderen!“ oder „Lange nicht gesehen und doch wiedererkannt!“. ',
        url: 'https://www.xing.com/news/insiders/articles/5-beige-flags-in-deinem-lebenslauf-die-du-sofort-loswerden-solltest-5800761',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/504/323/square_48/806bca39750db92d12d4ad6c89bf073b6cfc43f7image.jpg?1679654675',
      },
      {
        pageTitle: 'Dr. Bernd Slaghuis',
        title:
          'Teilzeit im Lebenslauf angeben? Warum es für deine Berufserfahrung egal ist, wie lange du im Büro gesessen hast',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/004/908/203/web_high/fa62863e3b2fc001667208bfba4a5e6587885c66image.jpg?1656965569',
        description:
          'Muss eine Position in Teilzeit im Lebenslauf als solche kenntlich gemacht werden? Der Fall von Laura Dornheim und ihrer geplatzten Wahl zu Münchens neuer IT-Referentin sorgt für viel Diskussion im Netz.  ',
        url: 'https://www.xing.com/news/insiders/articles/teilzeit-im-lebenslauf-angeben-warum-es-fur-deine-berufserfahrung-egal-ist-wie-lange-du-im-buro-gesessen-hast-4979004',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/786/767/square_48/1fc60bb470b3e42e790126a6eb6529183981db0eimage.jpg?1690622987',
      },
      {
        pageTitle: 'Vanessa Weber',
        title:
          'Sieben Lücken im Lebenslauf, die Deine Bewerbung nur interessanter machen',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/535/287/web_high/33a04cdcff1aa973cb01bea44e0dcf456dbb50edimage.jpg?1680779156',
        description:
          'Mut zur Lücke! Du hast die Phase zwischen zwei Jobs sinnvoll genutzt? Dann kehre sie bei der Bewerbung nicht unter den Teppich, sondern putze sie fein heraus.',
        url: 'https://www.xing.com/news/insiders/articles/sieben-lucken-im-lebenslauf-die-deine-bewerbung-nur-interessanter-machen-5630956',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/004/206/744/square_48/21343eabe7953c1e9e145a7e872125bd9f9972cdimage.jpg?1637574900',
      },
      {
        pageTitle: 'Claus Verfürth',
        title:
          'Bewerben als Top-Führungskraft: So wird Ihr CV zum Türöffner für Ihre neue Spitzenposition',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiYjMxOWRjM2MtMTRmMS00MTdmLTllMGEtNzFhNDlhMTc4MTU4IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=aba81dbdb3d4ff8069a722d6cbc2d45887471f91f86dd0b56590b0e893d60c44',
        description:
          'Wer sich als Top-Führungskraft bewerben will, sollte auch einige Besonderheiten beachten, die für eine Bewerbung im Topmanagement gelten.',
        url: 'https://www.xing.com/news/article/bewerben-als-top-fuehrungskraft-so',
        profileImage:
          'https://profile-images.xing.com/images/c052d770c9da1e8c2b321d69fdab7e9a-4/claus-verf%C3%BCrth.256x256.jpg',
      },
      {
        pageTitle: 'Tanja Jakob',
        title:
          'Karrierebruch oder wertvolle Erfahrung? Elternzeit im Lebenslauf gekonnt in Szene setzen',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/757/954/web_high/17ffcea920ee6956fd1d1861ae5120b55bfc6803image.jpg?1689585055',
        description:
          'Viele berufstätige Mütter fragen sich, wie sie die Elternzeit im Lebenslauf angeben und ihre neu erworbenen Fähigkeiten als Mutter im Lebenslauf als wertvolle Erfahrungen präsentieren können.',
        url: 'https://www.xing.com/news/insiders/articles/karrierebruch-oder-wertvolle-erfahrung-elternzeit-im-lebenslauf-gekonnt-in-szene-setzen-5853503',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/738/136/square_48/690b45f3acf9853d0eedb52df8acd518339b60edimage.jpg?1688725982',
      },
    ],
  },
  {
    title: 'Tipps zum Vorstellungsgespräch',
    slug: 'bewerbung/vorstellungsgespräch',
    articles: [
      {
        pageTitle: 'XING Insider',
        title:
          'Mach Dich nicht kleiner, als Du bist! 8 Tipps, wie Du im Bewerbungsgespräch auf Augenhöhe bleibst',
        description:
          'Ein Vorstellungsgespräch kann eine herausfordernde Situation sein: Wer nicht auf Augenhöhe mit dem potenziellen Arbeitgeber bleibt, geht unter. Mit diesen Insider-Tipps lässt sich das verhindern.',
        url: 'https://www.xing.com/news/articles/mach-dich-nicht-kleiner-als-du-bist-8-tipps-wie-du-im-bewerbungsgesprach-auf-augenhohe-bleibst-5810741',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/782/305/square_48/7cf2737a4bf39eec3af0c914b82238a978f0c188image.jpg?1690451921',
      },
      {
        pageTitle: 'Stefanie Saß',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZTVmODYxZDYtMWEwMy00MzkxLTgwNmYtYzZlNzE1MTJjNzM5IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=b967b41bfc74789437fd02438a46cb9ff3b10dbce2221ac488c289be55279c3a',
        title: '27 clevere Rückfragen für Ihr nächstes Vorstellungsgespräch',
        description:
          'Zum Ende jedes Bewerbungsgesprächs haben Sie die Möglichkeit, Rückfragen zu stellen. Häufig sagen Bewerber*innen aus Angst, einen schlechten Eindruck zu hinterlassen, dass nach dem Gespräch keine Fragen offengeblieben sind.',
        url: 'https://www.xing.com/news/article/27-clevere-rueckfragen-fuer-ihr-nae',
        profileImage:
          'https://profile-images.xing.com/images/28d088ae83adb88a9c2ac72e6e046983-3/stefanie-sa%C3%9F.256x256.jpg',
      },
      {
        pageTitle: '',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDNhYzNmZjYtOTJjMC00MDA0LWE5MDQtMjI5Y2Q0NzkwZmJkIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=762d369dee18907f4c98cb8b201231465429fdd665e73df1a0287ef40d8e61ca',
        title:
          'Golfen, Segeln, Reiten – mit diesen Hobbys bekommst Du das Vorstellungsgespräch',
        description:
          'Die „richtigen“ Hobbys in der Bewerbung anzugeben kann große Vorteile haben. Denn sie beeinflussen nicht selten HR-Verantwortliche und Manager bei der Bewerberauswahl. ',
        url: 'https://www.xing.com/news/article/golfen-segeln-reiten-mit-diesen-hob',
        profileImage: '',
      },
      {
        pageTitle: 'Silke Koppitz',
        imageSrc:
          'https://static.xingcdn.com/content/insider/header_images/images/005/574/718/web_high/1ff707e77d2423c3dda0e13dba7da6672b437d14image.jpg?1682439772',
        title:
          'Warnzeichen im Vorstellungsgespräch: Wann ist es Zeit, das Weite zu suchen?',
        description:
          'Was ist die absurdeste Frage, die dir je in einem Vorstellungsgespräch gestellt wurde?* Bei diessen 10 Warnzeichen solltest du aufhorchen und (nicht nur in Gedanken) rückwärts aus dem Meeting moonwalken. ',
        url: 'https://www.xing.com/news/insiders/articles/warnzeichen-im-vorstellungsgesprach-wann-ist-es-zeit-das-weite-zu-suchen-5660878',
        profileImage:
          'https://static.xingcdn.com/content/cpp/page_logo_images/images/005/504/323/square_48/806bca39750db92d12d4ad6c89bf073b6cfc43f7image.jpg?1679654675',
      },
      {
        pageTitle: 'Dr. Branjo Woischwill',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZDI3YWJjMmUtOWQ2Ny00YTkwLTkxMmUtODZkODZlNTE5YWZjIiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=443226e37ceaa8252f8dd1047880da1c859f31fdbe2c2ba97ec40eab17ebbf78',
        title:
          'Genial oder gefährlich? Vorstellungsgesprächs-Training mit ChatGPT',
        description:
          'Vorbereitung mit ChatGPT auf ein Job-Interview? Bei einer Fähigkeit kann die KI nicht mithalten...',
        url: 'https://www.xing.com/news/article/genial-oder-gefaehrlich-vorstellung',
        profileImage:
          'https://profile-images.xing.com/images/79aaa3684abf509186c60a82700d77a2-4/branko-woischwill.256x256.jpg',
      },
      {
        pageTitle: 'Henryk Lüderitz',
        imageSrc:
          'https://www.xing.com/imagecache/public/scaled_original_image/eyJ1dWlkIjoiZTJkYWVjMmYtNmQ5MS00YmVmLWEwNGYtYWY5NjQyNjU4OWE2IiwiYXBwX2NvbnRleHQiOiJhcnRpY2xlcyIsIm1heF93aWR0aCI6OTM2LCJtYXhfaGVpZ2h0Ijo1Mjd9?signature=090ddc28d4aeb2b7d772ff31e63f783528d91a891541df1f4f23f0fe4c222206',
        title:
          'Gehaltsfrage im Vorstellungsgespräch – diese drei Fehler musst du unbedingt vermeiden!',
        description:
          '„Was soll ich nur sagen, wenn ich im Vorstellungsgespräch auf mein Gehalt angesprochen werde?“ So selbstverständlich und nachvollziehbar die Gehaltsfrage auch ist, sie sorgt bei Bewerber:innen nach wie vor für Angst und Schrecken.',
        url: 'https://www.xing.com/news/article/gehaltsfrage-im-vorstellungsgesprae',
        profileImage:
          'https://profile-images.xing.com/images/cb252ad7461e882678d19dd781a4e127-12/henryk-l%C3%BCderitz.256x256.jpg',
      },
    ],
  },
];
